




















































































import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import UngulatesBearsReport = Orders.UngulatesBearsReport;

@Component({
  name: 'UngulatesComponent',
})
export default class UngulatesComponent extends Vue {
  @Prop({ required: true, type: Array })
  reports!: Array<UngulatesBearsReport>;

  genders = {
    1: 'Мужской',
    2: 'Женский',
  };

  gender(gen: string): string {
    return this.genders[gen];
  }

  get ungulates(): Array<any> {
    if (this.reports && this.reports.length > 0) {
      return this.reports;
    }
    return [];
  }

  padding(index: number): string {
    if (index > 0) {
      return 'q-pt-lg';
    }
    return '';
  }
}
